const personalCardWrapper = document.querySelector('.side-panel-personal-card');
if (personalCardWrapper) personalCardScripts();

function personalCardScripts() {
	const personalCardWrapperUpdated = document.querySelector('.side-panel-personal-card');
	if (!personalCardWrapperUpdated) return;

	const personalCardTextarea = personalCardWrapperUpdated.querySelector('textarea.personal-card-text-area');

	function sanitizeInput(value) {
		const emojiRegex = /([\p{Extended_Pictographic}|\u200D]+)/gu;
		const allowedCharsRegex = /[^\w\s.,!?æøåÆØÅ:\-']/g;
		return value
			.replace(emojiRegex, '')
			.replace(allowedCharsRegex, '');
	}

	personalCardTextarea.addEventListener("input", function () {
		this.value = sanitizeInput(this.value);
	});

	personalCardTextarea.addEventListener("paste", function (e) {
		e.preventDefault();
		const pasted = (e.clipboardData || window.clipboardData).getData('text');
		const sanitized = sanitizeInput(pasted);
		document.execCommand("insertText", false, sanitized);
	});
}

const handleCartUpdate = () => {
	setTimeout(() => {
		if (personalCardWrapper) personalCardScripts();
	}, 2000);
};

document.addEventListener("cart:item-removed", handleCartUpdate);
document.addEventListener("cart:item-updated", handleCartUpdate);
document.addEventListener("cart-drawer:open", handleCartUpdate);
